export default __webpack_public_path__ + "static/dragon-d75cfa0c676a341926a131336b20adcd.jpg";